<template>
    <div class="my-3">
        <patient-updates-filter
            :patient-updates-filter="patientUpdatesFilter"
            @set-parent-prop="propSetFromChild($event)"
        ></patient-updates-filter>

        <div class="my-3">
            <div
                v-for="t in therapists.filter(t => {
                    if (patientUpdatesFilter === 0) {
                        return t.group === 1;
                    } else {
                        return true;
                    }
                })"
            >
                <div class="therapist-line position-relative">
                    <div class="row">
                        <div class="col-3">
                            <img
                                class="position-absolute therapist-picture"
                                :src="t.image || '../../../images/default_user.jpeg'"
                                alt=""
                            />
                        </div>
                        <div class="col-9">
                            <p class="mb-0">
                                <b>{{ t.title }} - {{ t.name }}</b>
                            </p>
                            <small class="mb-0"
                                >Updated {{ t.last_update.data }} -
                                {{ moment(t.last_update.date).format("MMMM DD, YYYY") }}</small
                            >
                        </div>
                    </div>
                </div>
                <div class="px-3">
                    <div
                        class="row bg-white pr-3 py-2 cursor-pointer"
                        v-for="uf in updates.filter(u => u.therapist_id === t.id)"
                    >
                        <div class="col-3"></div>
                        <div class="col-9 d-flex justify-content-between align-items-center">
                            <p class="text-muted mb-0">{{ uf.goal }}</p>
                            <i class="text-primary fa fa-chevron-circle-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PatientUpdatesFilter from "./PatientUpdatesFilter";

export default {
    name: "PatientUpdates",
    components: {
        PatientUpdatesFilter,
    },
    data() {
        return {
            patientUpdatesFilter: 0,
            therapists: [
                {
                    id: 1,
                    group: 1,
                    name: "Amy Lee",
                    title: "SLP",
                    last_update: { date: "2018-06-25", data: "Goals" },
                },
                {
                    id: 2,
                    group: 1,
                    name: "Laura Foster",
                    title: "ABA",
                    last_update: { date: "2018-06-25", data: "Progress" },
                },
                {
                    id: 3,
                    group: 1,
                    name: "Edna Schmidt",
                    title: "DIR",
                    last_update: { date: "2018-06-25", data: "Goals" },
                },
                {
                    id: 4,
                    group: 2,
                    name: "Jenna Palmer",
                    title: "DIR",
                    last_update: { date: "2018-06-25", data: "Goals" },
                },
                {
                    id: 5,
                    group: 2,
                    name: "Mary Hart",
                    title: "DIR",
                    last_update: { date: "2018-06-25", data: "Goals" },
                },
            ],
            updates: [
                { therapist_id: 1, goal: "5 Action Words" },
                { therapist_id: 1, goal: "5 Action Words" },
                { therapist_id: 1, goal: "5 Action Words" },
                { therapist_id: 2, goal: "5 Action Words" },
                { therapist_id: 3, goal: "5 Action Words" },
                { therapist_id: 3, goal: "5 Action Words" },
                { therapist_id: 4, goal: "5 Action Words" },
                { therapist_id: 4, goal: "5 Action Words" },
                { therapist_id: 5, goal: "5 Action Words" },
                { therapist_id: 5, goal: "5 Action Words" },
                { therapist_id: 5, goal: "5 Action Words" },
            ],
        };
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.therapist-picture {
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    border: solid 3px #ffffff;
    right: 0;
    top: -0.5rem;
}
.therapist-line {
    background-color: #e8e8e8;
    max-height: 3rem;
}
</style>
